/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import {
  Layout, Menu, Button, Avatar, Icon, Popover, Drawer,
} from 'antd'
import { compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import logo from '../img/logo_race.png'
import { logoutUser } from '../auth'

import '../App.css'
import {
  Headercomponents,
  HeaderIconcomponents,
  HeaderReponcomponents,
  HeaderIconReponcomponents,
  Responsivecomponents,
} from './styled-components/headerStyled'

class HeaderContainer extends Component {
  state = {
    visible: false,
  };
  showDrawer = () => {
    this.setState({
      visible: true,
    })
  };

  onClose = () => {
    this.setState({
      visible: false,
    })
  };
  render() {
    const { Header } = Layout
    const handleLogout = () => {
      logoutUser().then(() => {
        this.props.client.resetStore()
        this.props.history.push('/login')
      })
    }
    // const text = <span>Name</span>
    const content = (
      <div>
        <p><Button type="link" href="/home">Profile</Button></p>
        <p><Button type="link" onClick={() => handleLogout()}>Logout</Button></p>
      </div>
    )
    return (
      <Header style={{ display: 'flex' }}>
        <Headercomponents>
          <div>
            <img src={logo} style={{ width: '50px' }} alt="logo" />
          </div>
          <Menu
            mode="horizontal"
            defaultSelectedKeys={['2']}
            style={{ lineHeight: '64px' }}
            className="Header"
          >
            <Menu.Item style={{ fontSize: '20px' }} key="1">
              <a
                href="https://www.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
              >
                Thai.run
              </a>
            </Menu.Item>
            <Menu.Item style={{ fontSize: '20px' }} key="2">
              <a
                href="https://race.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
              >
                Race
              </a>
            </Menu.Item>
            <Menu.Item style={{ fontSize: '20px' }} key="3">
              <a
                href="https://vr.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
              >
                Vr
              </a>
            </Menu.Item>
            <Menu.Item style={{ fontSize: '20px' }} key="4">
              <a
                href="https://shop.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
              >
                Shop
              </a>
            </Menu.Item>
            <Menu.Item style={{ fontSize: '20px' }} key="5">
              <a
                href="https://photo.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
              >
                Photo
              </a>
            </Menu.Item>
          </Menu>
        </Headercomponents>
        <HeaderIconcomponents>
          <Button
            size="large"
            style={{
              backgroundColor: '#f4783c', borderColor: '#f4783c', color: '#fff', fontWeight: 'bold', fontSize: '20px', marginRight: '20px', borderRadius: '12px',
            }}
          >งานวิ่งของฉัน
          </Button>
          <Popover placement="bottom" content={content} trigger="click">
            <Button
              size="large"
              style={{
                borderColor: '#f4783c', color: '#666', fontWeight: 'bold', fontSize: '20px', borderRadius: '12px',
              }}
            >
              <Avatar icon="user" style={{ marginRight: '8px', backgroundColor: '#87d068' }} />
              Fah S.
              <Icon type="down" style={{ fontWeight: 'bold', fontSize: '13px' }} />
            </Button>
          </Popover>
        </HeaderIconcomponents>
        <Responsivecomponents>
          <HeaderReponcomponents>
            <div>
              <img src={logo} style={{ width: '50px' }} alt="logo" />
            </div>
          </HeaderReponcomponents>
          <HeaderIconReponcomponents>
            <Icon onClick={this.showDrawer} type="menu-unfold" style={{ fontSize: '30px', color: '#F4783C' }} />
          </HeaderIconReponcomponents>
        </Responsivecomponents>
        <Drawer
          placement={this.state.placement}
          onClose={this.onClose}
          visible={this.state.visible}
          style={{ backgroundColor: '#F4783C' }}
        >
          <Menu
            defaultSelectedKeys={['1']}
            defaultOpenKeys={['sub1']}
            mode="inline"
            inlineCollapsed={this.state.collapsed}
          >
            <Menu.Item key="1">
              <a
                href="https://www.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
                style={{ fontSize: '20px' }}
              >
                Thai.run
              </a>
            </Menu.Item>
            <Menu.Item key="2">
              <a
                href="https://race.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
                style={{ fontSize: '20px' }}
              >
                Race
              </a>
            </Menu.Item>
            <Menu.Item key="3">
              <a
                href="https://vr.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
                style={{ fontSize: '20px' }}
              >
                Vr
              </a>
            </Menu.Item>
            <Menu.Item key="4">
              <a
                href="https://shop.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
                style={{ fontSize: '20px' }}
              >
                Shop
              </a>
            </Menu.Item>
            <Menu.Item key="5">
              <a
                href="https://photo.thai.run/"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
                style={{ fontSize: '20px' }}
              >
                Photo
              </a>
            </Menu.Item>
            <Menu.Item key="6">
              <a
                href="/home"
                target="_blank"
                rel="noopener noreferrer"
                alt=""
                style={{ fontSize: '20px' }}
              >
                งานวิ่งของฉัน
              </a>
            </Menu.Item>
            <div style={{ borderBottom: '3px solid #000' }} />
            <Menu.Item key="7">
              {/* <Icon style={{ fontSize: '20px' }} type="user" /> */}
              <Avatar icon="user" style={{ marginRight: '8px', backgroundColor: '#87d068' }} />
              <span style={{ fontSize: '20px' }}>Jir</span>
            </Menu.Item>
            <Menu.Item key="8" onClick={() => handleLogout()}>
              <Icon style={{ fontSize: '20px' }} type="logout" />
              <span style={{ fontSize: '20px' }}>Logout</span>
            </Menu.Item>
            <div style={{ borderTop: '3px solid #000' }} />
          </Menu>
        </Drawer>
      </Header>
    )
  }
}
export default compose(
  withRouter,
  withApollo
)(HeaderContainer)



// WEBPACK FOOTER //
// ./src/components/header.js